import { render, staticRenderFns } from "./EnterMarks.vue?vue&type=template&id=4e1d6753&scoped=true"
import script from "./EnterMarks.vue?vue&type=script&lang=js"
export * from "./EnterMarks.vue?vue&type=script&lang=js"
import style0 from "./EnterMarks.vue?vue&type=style&index=0&id=4e1d6753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d6753",
  null
  
)

export default component.exports